import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Field, Control } from "rbx";
import moment from "moment";
import gql from "graphql-tag";
import { useQuery } from "react-apollo";
import { OrdersTable } from "../../../components/Orders";
import PageHeader from "../../../components/PageHeader";
import { ORDER_VIEW_COLUMNS } from "./columns";

import { ALL_ORDERS_VIEW_BY_PAGE_QUERY } from "../../../graphql/Orders/Orders.graphql";

import OrderFilters from "./OrderReprintFilters";
import {
  getFilterState,
  saveFilterState,
  ourToast as toast
} from "../../../utils";

import OrderStatusFilter from "./OrderReprintStatusFilter";
import Loading from "../../../components/Loading";

const ALL_SYSTEM_CODES_QUERY = gql`
  query SystemCodes($where: SystemCodeWhereInput!) {
    SystemCodes(where: $where) {
      RecId
      Type
      Category
      CodeName
      CodeId
      CodeDescription
    }
  }
`;

const DEFAULT_FILTERS = {};

function OrderReprintPage() {
  const SystemCodes = useQuery(ALL_SYSTEM_CODES_QUERY, {
    variables: {
      where: {
        Category: "Order",
        CodeName: "OrderStatus",
        CodeId: "BP"
      }
    }
  });
  const history = useHistory();
  const INITIAL_FILTER_STATE = getFilterState("ORDER_REPRINT_FILTERS", {
    ...DEFAULT_FILTERS
  });

  const [filters, setFilters] = useState({ ...INITIAL_FILTER_STATE });
  const [codes, setCodes] = useState(null);
  const [selectedFlatRows, setSelectedFlatRows] = useState([]);

  useEffect(() => {
    if (Array.isArray(SystemCodes?.data?.SystemCodes) && !codes) {
      setCodes(
        SystemCodes.data.SystemCodes.map(({ RecId, CodeDescription }) => ({
          value: RecId,
          label: CodeDescription
        }))
      );
      if (
        SystemCodes?.data?.SystemCodes?.length > 0 &&
        !filters.StatusRecIdRef
      ) {
        setFilters({
          ...filters,
          StatusRecIdRef: SystemCodes.data.SystemCodes[0].RecId
        });
      }
    }
  }, [filters, INITIAL_FILTER_STATE, SystemCodes, codes]);

  const handleSetFilters = inputs => {
    saveFilterState("ORDER_REPRINT_FILTERS", inputs);
    setFilters({ ...inputs });
  };
  const resetFilters = () => handleSetFilters({ ...DEFAULT_FILTERS });

  // this enables us to use to / from === same day but still query a range
  const parseFilters = input => {
    const where = { ...input };
    if (input.PickupDate_gt) {
      where.PickupDate_gt = moment(input.PickupDate_gt)
        .startOf("day")
        .toISOString();
    }
    if (input.PickupDate_lt) {
      where.PickupDate_lt = moment(input.PickupDate_lt)
        .endOf("day")
        .toISOString();
    }
    if (input.OrderDate_gt) {
      where.OrderDate_gt = moment(input.OrderDate_gt)
        .startOf("day")
        .toISOString();
    }
    if (input.OrderDate_lt) {
      where.OrderDate_lt = moment(input.OrderDate_lt)
        .endOf("day")
        .toISOString();
    }
    if (input.InvoiceDate_gt) {
      where.InvoiceDate_gt = moment(input.InvoiceDate_gt)
        .startOf("day")
        .toISOString();
    }
    if (input.InvoiceDate_lt) {
      where.InvoiceDate_lt = moment(input.InvoiceDate_lt)
        .endOf("day")
        .toISOString();
    }
    return where;
  };

  const printInvoices = selectedData => {
    if (selectedData.length > 0) {
      const {
        REACT_APP_REPORT_BASE_URL = "https://gdev.gravoc.com"
      } = process.env;
      const BASE_URL = `${REACT_APP_REPORT_BASE_URL}/ReportViewer/ReportViewer.aspx?Path=Invoice`;
      const REPORT_URL = `${BASE_URL}&Param=InvoiceNumber&ParamValue=${selectedData.join()}`;
      window.open(REPORT_URL);
      setSelectedFlatRows([]);
    } else {
      toast.error("Please select an invoice to reprint.");
    }
  };

  if (!filters.StatusRecIdRef || !codes) {
    return <Loading />;
  }

  return (
    <React.Fragment>
      <PageHeader
        FilterComponent={OrderFilters}
        columns={ORDER_VIEW_COLUMNS}
        filters={parseFilters(filters)}
        name="VW_OrdersByPage"
        orderByMulti={["InvoiceNumber_ASC", "OrderNumber_ASC"]}
        query={ALL_ORDERS_VIEW_BY_PAGE_QUERY}
        resetFilters={resetFilters}
        setFilters={handleSetFilters}
        title="Invoice Reprint"
        onAddClick={() => {
          history.push("/dispatch/orders/new");
        }}
      />
      <Field>
        <Control>
          <OrderStatusFilter filters={filters} options={codes} />
        </Control>
      </Field>
      <OrdersTable
        columns={ORDER_VIEW_COLUMNS}
        initialSortBy={[
          { id: "InvoiceNumber", desc: false },
          { id: "OrderNumber", desc: false }
        ]}
        printInvoices={printInvoices}
        selectedFlatRows={selectedFlatRows}
        setSelectedFlatRows={setSelectedFlatRows}
        where={parseFilters(filters)}
        onCellClick={cell => {
          if (cell.column.id !== "selection") {
            history.push(`/dispatch/orders/${cell.row.original.RecId}/summary`);
          }
        }}
      />
    </React.Fragment>
  );
}
OrderReprintPage.propTypes = {};
export default OrderReprintPage;
